import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import { getAllRewardTierStatusOptions } from '@/api/rewardTier/rewardTier.actions';
import { RewardTierStatusOption } from '@/api/rewardTier/rewardTier.types';
import { isApiSuccess } from '@/api/shared.types.ts';
import { useAsync } from '@/hooks/global/useAsync';

export const useRewardTierStatusOptions = (): {
  statusOptions: RewardTierStatusOption[];
  isLoading: boolean;
} => {
  const [statusOptions, setStatusOptions] = useState<RewardTierStatusOption[]>(
    []
  );
  const { run, isLoading } = useAsync();

  const fetchStatusOptions = async (): Promise<void> => {
    const response = await run(() => getAllRewardTierStatusOptions());
    if (!isApiSuccess(response)) {
      toast.error(response.error.message);
      return;
    }
    setStatusOptions(response.content.statusOptions);
  };

  useEffect(() => {
    fetchStatusOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    statusOptions,
    isLoading,
  };
};
